import React from "react";
import styles from './Footer.module.scss'

const Footer = () => {
    return (

        <div className={styles.footer}>
            <div className={styles.content}>@2023 Nourhan Elsherif</div>
        </div>

    )
}
export default Footer